<script>
  import { getContext } from 'svelte';
  import { link } from 'svelte-navigator';

  import { SignaturePreview } from '@client/components/signature-preview';

  import { userStore } from '@client/stores/user';

  export let row = {};

  const { basepath } = getContext('config');

  $: block = row?.blocks?.find((block) => block?.blockname === row?.blockname);
</script>

{#if block}
  <div class="blocks">
    <div class="block" class:active={block.status}>
      <span
        class="name"
        on:mouseenter={() => (block.show = true)}
        on:mouseleave={() => (block.show = false)}
        role="button"
        tabindex="0"
      >
        <a href="{basepath}/signatures/studio/{block.blockname}" use:link>{block.blockname}</a>

        {#if row.senders[0]}
          <SignaturePreview
            blockname={block.blockname}
            bind:show={block.show}
            user={{
              email:
                row.senders[0].username === '*'
                  ? `adminuser@${$userStore.domain}`
                  : `${row.senders[0].username}@${$userStore.domain}`
            }}
          />
        {/if}
      </span>
    </div>
  </div>
{/if}

<style lang="scss">
  .blocks {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .block {
    border: 1px solid var(--border-color);
    display: inline-flex;
    border-radius: var(--border-radius-base);
    color: var(--color-text);
    font-size: var(--font-size-small);

    a {
      color: var(--color-text);
      text-decoration: none;
    }

    .name {
      display: block;
      flex: 1;
      padding: var(--padding-small) var(--padding-base);
    }

    &:not(.active) {
      background-color: var(--color-gray-300);
    }

    .status {
      align-items: center;
      background-color: var(--color-gray-300);
      border-left: 1px solid var(--border-color);
      border-radius: 0 var(--border-radius-base) var(--border-radius-base) 0;
      display: flex;
      flex: 1;
      font-size: var(--font-size-xsmall);
      justify-content: center;
      padding: var(--padding-small) var(--padding-base);
      text-transform: uppercase;

      &.active {
        background-color: var(--color-blue-400);
        border-left: 1px solid var(--color-blue-400);
        box-shadow: 0 0 0 1px var(--color-blue-400);
        color: var(--color-white);
      }
    }
  }
</style>
